import { createContext } from "react";

const ProjectFormMapContext = createContext();

export default ProjectFormMapContext;